<template>
    <v-dialog v-model="showUserPayrollReportsDialog" scrollable>
        <v-card>
            <v-toolbar
                color="grey lighten-1"
            >
                <v-btn
                    class="mx-auto"
                    icon
                    small
                    color="black"
                    @click="showUserPayrollReportsDialog = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="">
                    <v-avatar color="white" size="34px">
                        <v-icon size="37" v-if="!selectedUserPayrollReport.Image">mdi-account-circle</v-icon>
                        <v-img :src="selectedUserPayrollReport.Image" v-else></v-img>
                    </v-avatar>
                </v-toolbar-title>

                <v-spacer></v-spacer>
            </v-toolbar>
            
            <v-card-text class="py-2 px-3">
                <v-tabs-items v-model="contentTab">
                    <v-tab-item value="defaultTab">
                        <DefaultTab>
                        </DefaultTab>
                    </v-tab-item>
                    <v-tab-item value="viewHistoryTab">
                        <ViewHistoryTab v-if="contentTab == 'viewHistoryTab'">
                        </ViewHistoryTab>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="contentTab == 'defaultTab'"
                    color="secondary"
                    text
                    @click="showUserPayrollReportsDialog = false"
                >
                    Close
                </v-btn>
                <v-btn
                    v-else
                    color="secondary"
                    text
                    @click="setContentTab('defaultTab')"
                >
                    Back
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// import axios from 'axios';
// import moment from "moment";
import {mapState, mapMutations, mapActions} from "vuex";

import DefaultTab from "./tabs/DefaultTab.vue";
import ViewHistoryTab from "./tabs/ViewHistoryTab.vue";

// const url = require("../../../client_config/config").url;

export default {
    components: {DefaultTab, ViewHistoryTab},

    props: {
        value: Boolean,
        selectedUserPayrollReport: Object,
    },
  
    data () {
        return {
            contentItems: ["defaultTab", "viewHistoryTab"]
        }
    },

    watch: {
        
    },

    computed: {
        ...mapState({
            contentTab: state => state.payrollReportsHistories.contentTab
        }),

        showUserPayrollReportsDialog: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value);
                this.setSelectedCompPanel(null);
                this.setSelectedDeductPanel(null);
            }
        },
    },

    created () {
        this.getStaff(this.selectedUserPayrollReport._id);
        this.setSelectedUserPayrollReport(this.selectedUserPayrollReport)
    },

    methods: {
        ...mapMutations({
            setContentTab: "payrollReportsHistories/setContentTab",
            setSelectedUserPayrollReport: "payrollReportsHistories/setSelectedUserPayrollReport",
            setSelectedCompPanel: "payrollReportsHistories/setSelectedCompPanel",
            setSelectedDeductPanel: "payrollReportsHistories/setSelectedDeductPanel",
        }),

        ...mapActions(
            "staff", [
                "getStaff"
            ]
        ),
    }
}
</script>